import { createContext, useEffect, useState } from "react";
export const AccountsContext = createContext({});
export const AccountsProvider = ({ children }) => {
  const [kitAccContext, setKitAccContext] = useState({});
  const [hostAccContext, setHostAccContext] = useState({});
  const [totalAccounts, setTotalAccounts] = useState(0);
  const [accounts, setAccounts] = useState({});
  useEffect(() => {
    const getAccounts = async () => {
      const hotelID = localStorage.getItem("hotelID");
      const requestBody = {
        hotelID: hotelID,
      };
      try {
        const response = await fetch(
          "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/affiliate/getaccounts",
          {
            method: "POST",
            headers: {
              "Content-type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );
        const result = await response.json();
        setAccounts(result);
      } catch (error) {
        console.log(error.message);
      }
      setTimeout(() => {
        getAccounts();
      }, 10000);
    };
    getAccounts();
  }, []);
  useEffect(() => {
    Object.keys(accounts).map((index) => {
      const tempObject = accounts[index];
      if (tempObject["accountType"] === "Host") {
        setHostAccContext({ ...hostAccContext, [index]: tempObject });
      } else if (tempObject["accountType"] === "Kitchen") {
        setKitAccContext({ ...kitAccContext, [index]: tempObject });
      }
    });
    setTotalAccounts(Object.keys(accounts).length);
  }, [accounts]);
  const deleteAccount = async (id) => {
    const requestBody = {
      ID: id,
    };
    const userToken = localStorage.getItem("user");
    try {
      const response = await fetch(
        "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/affiliate/deleteaccount",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "auth-token": userToken,
          },
          body: JSON.stringify(requestBody),
        }
      );
      const result = await response.text();
      if (result === "success") {
        window.location.reload();
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const value = {
    kitAccContext,
    setKitAccContext,
    setHostAccContext,
    hostAccContext,
    totalAccounts,
    deleteAccount,
  };
  return (
    <AccountsContext.Provider value={value}>
      {children}
    </AccountsContext.Provider>
  );
};
